import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div``;

export const Filter: any = styled.div`
  padding: 12px 16px;
  border-bottom: 1px solid rgba(${ColorPalette.RGB.PhilippineSilver}, 0.25);

  &.box {
    box-shadow: 0 0 5px 0 rgba(${ColorPalette.RGB.PineTree}, 0.15);
    margin-top: 0px;
    border-radius: 8px;
    padding: 12px 16px;
    background-color: ${ColorPalette.HEX.White};
  }

  & li {
    margin: 12px 0;
    font-size: 14px;
    display: flex;
  }
  & ul.star {
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
  }
`;

Filter.Title = styled.h5`
  font-size: 14px;
  line-height: 1.2em;
  margin: 10px 0 16px;
`;

Filter.Content = styled.div`
  margin-bottom: 10px;
`;

export const Checkbox = styled.div`
  width: 24px;
  height: 24px;
  border: 1px solid rgba(${ColorPalette.RGB.PhilippineSilver}, 0.25);
  margin-right: 16px;
`;

export const Circle = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 10px;
  border: 1px solid rgba(${ColorPalette.RGB.PhilippineSilver}, 0.25);
  margin-right: 16px;
`;
